export const FETCH_AUSENCIAS = "ausencia.fetch_ausencias";
